<template>
  <div class="course">
    <div class="Topba">
      <!-- <topBarnav></topBarnav> -->
      <div class="Top-tt">
        <img src="../../assets/introduce/course-banner.png" />
      </div>
      <div class="Top-bn">
        <span @click="checkMore">查看更多</span>
      </div>
    </div>
    <div class="item-course">
      <div class="item-course-title">
        <div class="main">
          <div class="xx-left"></div>
          <span class="cmp-b">各行各业专家名师制作精品课程</span>
          <div class="xx-right"></div>
        </div>
      </div>
      <div class="item-course-title">
        <div class="Course-box">
          <div v-for="(items, index) in courseData" :key="index" class="box">
            <div class="item-cq-image">
              <img :src="items.imgUrl" />
            </div>
            <span>{{ items.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-teacher">
      <div class="item-course-title">
        <div class="main1">
          <div class="xx-left"></div>
          <span class="cmp-b">各行各业专家名师</span>
          <div class="xx-right"></div>
        </div>
      </div>
      <div class="item-course-title">
        <div class="teacher-box">
          <div
            v-for="(items, index) in teacherList"
            :key="index"
            class="box-img"
          >
            <img :src="items.url" />
            <span>{{ items.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-ty">
      <span class="item-tex ffp"
        >现在创建书院，体验企业专属的创新、开放、共享、共赢的学习平台，</span
      >
      <span class="item-tex fft"
        >助力员工养成终身学习的习惯，不断提升职业能力，赋能企业创新发展。</span
      >
      <div class="item-course-title">
        <span class="item-bn" @click="loginNew">立即体验</span>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import topBarnav from "../introducePage/component/navbar";
import foot from "@/views/introducePage/component/footer";
import { setCookie, getCookie, removeCookie } from "@/utils/cookies";
export default {
  metaInfo() {
    return {
      title:
        this.$route.meta.title +
        "-明商道_企业培训系统_企业培训解决方案服务商-中潮教育",
      meta: [
        {
          name: "keyWords",
          content:
            "明商道,融E学,企业培训,企业培训系统,企业培训管理系统,企业书院,企业大学"
        },
        {
          name: "description",
          content:
            "融E学·明商道-企业一站式线上线下培训平台，包含线上选课、线上培训、讲师预约、会议直播、在线考试、能力测评、员工学习数据管理等定制化的应用，帮助您解决企业培训中任何烦恼。创建企业书院,占领商道制高点。"
        }
      ]
    };
  },
  name: "course",
  components: {
    foot,
    topBarnav
  },
  data() {
    return {
      courseData: [
        {
          imgUrl: require("../../assets/teacher/course1.png"),
          name: "市场营销前沿与实务"
        },
        {
          imgUrl: require("../../assets/teacher/course2.png"),
          name: "财务报表分析完整版"
        },
        {
          imgUrl: require("../../assets/teacher/course3.png"),
          name: "资本：道与术"
        },
        {
          imgUrl: require("../../assets/teacher/course4.png"),
          name: "管理者经济学思维训练"
        },
        {
          imgUrl: require("../../assets/teacher/course5.png"),
          name: "中国传统文化与全方位现代化"
        },
        {
          imgUrl: require("../../assets/teacher/course6.png"),
          name: "《民法典》之 —（基本合同制度）"
        },
        {
          imgUrl: require("../../assets/teacher/course7.png"),
          name: "高凝聚力团队打造"
        },
        {
          imgUrl: require("../../assets/teacher/course8.png"),
          name: "企业人力资源管理"
        }
      ],
      teacherList: [
        { url: require("../../assets/teacher/item1.png"), name: "杜 鹏" },
        { url: require("../../assets/teacher/item2.png"), name: "侯国跃" },
        { url: require("../../assets/teacher/item3.png"), name: "孟勤国" },
        { url: require("../../assets/teacher/item4.png"), name: "汪军民" },
        { url: require("../../assets/teacher/item5.png"), name: "张新民" },
        { url: require("../../assets/teacher/item6.png"), name: "李 昊" },
        { url: require("../../assets/teacher/item7.png"), name: "陈 芳" },
        { url: require("../../assets/teacher/item8.png"), name: "朱高正" }
      ]
    };
  },
  methods: {
    checkMore() {
      this.$router.push("/coursestore");
    },
    loginNew() {
      setCookie("redirectUrl", window.location.href);
      const Url = window.location.host;
      if (Url === "organ-test.i-ronge.com") {
        //测试网址
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "localhost:8080") {
        // 本地跳转
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "organ.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      } else if (Url === "business.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      }
    }
  }
};
</script>
<style scoped>
.Topba {
  width: 100%;
  height: 490px;
  background-image: url("../../assets/introduce/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: inline-block;
}
.Top-tt {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.Top-tt img {
  width: 1018px;
  height: 412px;
}
.Top-bn {
  display: flex;
  justify-content: center;
}
.Top-bn span {
  margin-top: -10px;
  display: block;
  width: 250px;
  height: 50px;
  background: #e95367;
  border-radius: 30px;
  font-size: 26px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  line-height: 50px;
  cursor: pointer;
}
.item-course {
  margin-top: 49px;
}
.item-course-title {
  width: 100%;
  display: flex;
  justify-content: center;
}
.main {
  width: 1000px;
  display: flex;
  justify-content: space-between;
}
.main1 {
  width: 780px;
  display: flex;
  justify-content: space-between;
}
.cmp-b {
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #254bc6;
  line-height: 48px;
}
.xx-left {
  margin-top: 25px;
  width: 240px;
  height: 2px;
  background: #254bc6;
}
.xx-right {
  margin-top: 25px;
  width: 240px;
  height: 2px;
  background: #254bc6;
}
.Course-box {
  width: 1200px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  flex-flow: wrap;
}
.box {
  width: 282px;
  margin-bottom: 25px;
  text-align: center;
}
.item-cq-image {
  width: 282px;
  height: 164px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  background: #ffffff;
}
.item-cq-image img {
  width: 268px;
  height: 150px;
  margin: 7px 7px 7px 7px;
}
.box span {
  display: block;
  padding-top: 13px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #353535;
}
.item-teacher {
  margin-top: 60px;
}
.teacher-box {
  width: 1200px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.box-img {
  width: 137px;
  text-align: center;
}
.box-img img {
  width: 137px;
  height: 169px;
}
.box-img span {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #353535;
}
.item-ty {
  display: inline-block;
  margin-top: 50px;
  width: 100%;
  height: 250px;
  background-image: url("../../assets/introduce/Layertc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.item-tex {
  display: block;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #fffefe;
}
.ffp {
  margin-top: 44px;
}
.fft {
  margin-top: 15px;
}
.item-bn {
  margin-top: 43px;
  display: block;
  width: 250px;
  height: 50px;
  background: #ffffff;
  border-radius: 25px;
  font-size: 24px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Medium;
  font-weight: 500;
  text-align: center;
  color: #1f61d0;
  line-height: 50px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/introducePage/course.vue